












import { Component, Vue } from 'vue-property-decorator';
@Component({ name: 'ApprovalStatusChangeInfoText' })
export default class ApprovalStatusChangeInfoText extends Vue {}
